import apiClient from '@/api/client';
import { API_ENDPOINTS } from '@/constants/apiEndpoints';

const TERMS = API_ENDPOINTS.TERMS;
const ADMIN_TERMS = API_ENDPOINTS.ADMIN_TERMS;
const KYC_LINK = API_ENDPOINTS.KYC_LINK;

class TermsAPI {
    /**
     * Get the active terms & conditions version (public).
     * @returns {Promise<{success: boolean, data: {id, version, title, content, updatedAt}|null}>}
     */
    async getActive() {
        return apiClient.get(TERMS.ACTIVE);
    }

    /**
     * Get whether the current user needs to accept a newer terms version.
     * Requires auth.
     */
    async getStatus() {
        return apiClient.get(TERMS.STATUS);
    }

    /**
     * Accept the active terms version for the current user. Requires auth.
     * @param {number} [termsVersionId]
     */
    async accept(termsVersionId) {
        return apiClient.post(TERMS.ACCEPT, termsVersionId ? { termsVersionId } : {});
    }

    /**
     * Accept the active terms version through a public KYC link.
     * @param {string} token
     */
    async linkAccept(token) {
        return apiClient.post(KYC_LINK.TERMS_ACCEPT, {}, { token });
    }

    // ------------------------- Admin -------------------------

    async adminList() {
        return apiClient.get(ADMIN_TERMS.LIST);
    }

    async adminGetActive() {
        return apiClient.get(ADMIN_TERMS.ACTIVE);
    }

    async adminCreate(data) {
        return apiClient.post(ADMIN_TERMS.CREATE, data);
    }

    async adminUpdate(id, data) {
        return apiClient.put(ADMIN_TERMS.UPDATE, data, { id });
    }

    async adminActivate(id) {
        return apiClient.post(ADMIN_TERMS.ACTIVATE, {}, { id });
    }
}

const termsAPI = new TermsAPI();

export default termsAPI;